/* eslint-disable no-unused-vars */
/**
 * © [2022] Conduent, Inc. All rights reserved. Conduent®and Conduent Agile
 * Star®are trademarks of Conduent, Inc. and/or its subsidiaries in the United
 * States and/or other countries.
 */

export const HANDLE_ERROR_MSG_LB = "HANDLE_ERROR_MSG_LB";
export const GET_LABELER_DIFFERENCES = "GET_LABELER_DIFFERENCES";
export const GET_LABELER_DIFFERENCES_CONTRACT =
  "GET_LABELER_DIFFERENCES_CONTRACT";
export const GET_CONTACT_DIFFERENCES_MFG = "GET_CONTACT_DIFFERENCES_MFG";
export const GET_CONTACT_DIFFERENCES_CMS = "GET_CONTACT_DIFFERENCES_CMS";
export const SAVE_LABELER_DIFFERENCES = "SAVE_LABELER_DIFFERENCES";
export const CLEAR_REDUX_LALELAR_DIFF = "CLEAR_REDUX_LALELAR_DIFF";
export const INPUT_FIELD_VALUE = "INPUT_FIELD_VALUE";
export const MFG_ID = "MFG_ID";
export const SINGLE_LABELER_DATA="SINGLE_LABELER_DATA";
export const LABELER_DIFF_TAB_DATA = "LABELER_DIFF_TAB_DATA";
export const GET_CHECKED_VALUE="GET_CHECKED_VALUE";
export const GET_TAB_VALUE="GET_TAB_VALUE";